module.exports = __webpack_public_path__ + "static/media/cagliostro-lose.1c46824e.png";